<template>
  <v-app>
    <navigation />
    <!-- <NavDrawer></NavDrawer> -->
    <v-content>
      <router-view />
    </v-content>

    <v-app-bar
      bottom
      flat
      color="white"
      height="250"
      :src="require('./assets/footer.png')"
    >
      <v-row>
        <v-col class="text-center" cols="12">
          {{ new Date().getFullYear() }} —
          <strong>Bayelsa State Board of Internal Revenue</strong>
        </v-col>
      </v-row>
    </v-app-bar>
  </v-app>
</template>

<script>
import Navigation from "./components/nav-bar.vue";

export default {
  name: "App",
  components: {
    navigation: Navigation,
  },

  data: () => ({
    items: [
      { title: "Home", icon: "mdi-view-dashboard" },
      { title: "About", icon: "mdi-forum" },
    ],
    links: ["Home", "Contacts", "Settings"],
    // drawer: this.$store.state.drawer,
  }),
  computed: {},
  created() {},
};
</script>
